import { createContext } from 'react';
import { SelectedOrgUnitState } from './state';

export const SelectedOrgUnitContext = createContext<SelectedOrgUnitState | null>(null);

export const SelectedOrgUnitProvider = SelectedOrgUnitContext.Provider;
